import React from 'react';
import moment from 'moment';
import { Radio, Collapse } from '@blueprintjs/core';
import { LetterProcessingWorkFlow } from 'api';
import { Link } from 'react-router';
import { TextMessage } from 'components/tt-forms/common';
import { ShowIf } from 'components/utils';

let classNames = require('classnames');

class LetterHistory extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      DataLichSuQuaTrinhXuLy: [],
      isOpen: true
    }
  }

  componentDidMount() {
    this.getQuyTrinhXuLyHistory(this.props.donId);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.donId != this.props.donId) {
      this.getQuyTrinhXuLyHistory(nextProps.donId);
    }
  }

  getQuyTrinhXuLyHistory(inputId) {
    LetterProcessingWorkFlow.actions.getQuyTrinhXuLyHistory.request({ donId: inputId }).then(res => {
      if (res.data._embedded) {
        this.setState({ DataLichSuQuaTrinhXuLy: res.data._embedded.lichSuQuaTrinhXuLies });
      } else {
        this.setState({ DataLichSuQuaTrinhXuLy: [] });
      }
    })
  }

  handleCollapse() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {

    let listLichSuQuyTrinhXuLy = this.state.DataLichSuQuaTrinhXuLy.map((item, i) => {

      let ngayXuLy = moment(item.ngayXuLy).format('DD/MM/YYYY - HH:mm');
      return (
        <div key={i} className="history-items">
          <div className="radio-column">
            <Radio defaultChecked={true} />
          </div>
          <div className="group-val">
            <span className="txt-bold txt-upper">{item.ten == 'Đình chỉ' ? (this.props.ma != '' ? 'Đình chỉ' : 'Rút đơn') : item.ten}</span>
            <span className="val-content">{ngayXuLy}</span>
          </div>
          <div className="group-val">
            <span className="txt-bold">Người xử lý:</span>
            <span className="val-content">{item.nguoiXuLyText}</span>
          </div>
          <div className="group-val">
            <span className="txt-bold">Nội dung:</span>
            <TextMessage
              className="val-content"
              value={item.noiDung || ''}/>
          </div>
        </div>
      )
    });

    let classTitle = ['rows'];
    let classHistory = ['wrap-history'];

    if (this.props.pageType == 'THEM_MOI_VA_CHINH_SUA_DON') {
      classTitle.push(['pl5', 'pr5']);
      classHistory.push(['pl5', 'pr5']);
    }

    return (
      <ShowIf condition={this.state.DataLichSuQuaTrinhXuLy.length > 0}>
        <div className="page-wrapper">
          <div className="box-items">
            <div className="box-forward">
              <div className="container-box">
                <div className="group-box">
                  <div className="title">
                    <div className={classNames(classTitle)}>
                      <h3 className={this.state.isOpen ? " collapse-title collapse-open" : "collapse-title collapse-close"}><Link className="title-14" onClick={this.handleCollapse.bind(this)}>Quá trình xử lý</Link></h3>
                    </div>
                  </div>
                  <Collapse className={classNames(classHistory)} isOpen={this.state.isOpen}>
                    {listLichSuQuyTrinhXuLy}
                  </Collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ShowIf>
    );
  }
}

LetterHistory.defaultProps = {
  pageType: 'CHI_TIET_DON',
  donId: ''
}

export default LetterHistory;



// WEBPACK FOOTER //
// ./src/components/modules/letter-history/LetterHistory.jsx